import { COLOR } from 'app-v2/design-tokens'
import { Icon } from 'app-v2/shared/features/icon'
import { Chevron } from 'app/assets/icons'
import { CaptionText } from 'app/common/typography'
import type { Element } from 'react'
import React from 'react'
import styled from 'styled-components'

type Props = {
    title: Element<any>,
    description: string,
    collectChoice: string,
    handleClick: (collectMode: string) => Promise<any>,
    image?: string,
    iconCode?: any,
    iconColor?: string,
    iconSize?: number,
    url: string
}

export const WidgetCollectMode = ({
    title,
    description,
    image,
    handleClick,
    collectChoice,
    iconCode,
    iconColor,
    iconSize
}: Props) => {
    return (
        <Widget
            onClick={async () => {
                await handleClick(collectChoice)
            }}>
            <Content>
                <Left>
                    {!!image && (
                        <ImageContainer>
                            <img src={image} height="100%" alt={title} />
                        </ImageContainer>
                    )}
                    {!!iconCode && (
                        <Icon
                            code={iconCode}
                            color={iconColor}
                            size={iconSize}
                        />
                    )}
                    <Infos>
                        {!!title && title}
                        <TextDescription>{description}</TextDescription>
                    </Infos>
                </Left>
            </Content>
            <Right>
                <Chevron color={COLOR.PRIMARY} />
            </Right>
        </Widget>
    )
}

const Widget = styled.div`
    padding: 15px;
    background-color: white;
    border-radius: 12px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin: 5px 20px 10px;
    justify-content: space-between;
    cursor: pointer;
`

const Right = styled.div`
    display: flex;
`

const Content = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`

const Infos = styled.div`
    color: ${COLOR.PRIMARY};
    margin-left: 20px;
`

const Left = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`

const TextDescription = styled(CaptionText)`
    color: ${COLOR.PRIMARY};
`

const ImageContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 45px;
    height: 45px;
`
